import { EyeSlashIcon as PhosphorEyeSlashIcon } from "@phosphor-icons/react/dist/ssr/EyeSlash";

import { createAppIcon } from "@/components/createAppIcon";

export const HiddenIcon = /* @__PURE__ */ createAppIcon(PhosphorEyeSlashIcon);
